import { createTheme } from '@mui/material/styles';

export const   theme = (themeMode: 'light' | 'dark') => 
    createTheme({
    palette: {
        mode: themeMode,
        ...(themeMode === 'dark'
            ? {
                background: {
                    default: '#2b2b2b',
                    paper: '#323232',
                },
                text: {
                    primary: '#ffffff',
                    secondary: '#b0b0b0',
                },
                link: {
                    main: '#80b3ff', // Link color in dark mode
                    hover: '#3399ff', // Hover state color for links
                },
                divider: '#616161', // Divider lines
            }
            : {
                background: {
                    default: '#ffffff',
                    paper: '#ffffff',
                },
                text: {
                    primary: '#000000',
                    secondary: '#424242',
                },
                link: {
                    main: '#1976d2', // Link color in light mode
                    hover: '#115293', // Hover state color for links
                },
                divider: '#e0e0e0',
            }),
    },
    typography: {
        fontFamily: 'Roboto, Arial, sans-serif',
    },
});

export const theme2 = (themeMode: 'light' | 'dark') =>
    createTheme({
        palette: {
            mode: themeMode,
            ...(themeMode === 'dark'
                ? {
                    background: {
                        default: '#2b2b2b', // Main background
                        paper: '#424242', // Cards and panels
                    },
                    text: {
                        primary: '#ffffff', // Text color
                        secondary: '#b0b0b0', // Secondary text color
                    },
                    divider: '#616161', // Divider lines
                }
                : {
                    background: {
                        default: '#f5f5f5', // Light background
                        paper: '#ffffff', // Cards and panels
                    },
                    text: {
                        primary: '#000000',
                        secondary: '#424242',
                    },
                    divider: '#e0e0e0',
                }),
        },
        typography: {
            fontFamily: 'Roboto, Arial, sans-serif',
            fontSize: 14,
            h6: {
                fontWeight: 700, // Bold titles
            },
            subtitle2: {
                color: themeMode === 'dark' ? '#b0b0b0' : '#616161',
            },
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    body: {
                        backgroundColor: themeMode === 'dark' ? '#2b2b2b' : '#f5f5f5',
                        color: themeMode === 'dark' ? '#ffffff' : '#000000',
                    },
                },
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        backgroundColor: themeMode === 'dark' ? '#424242' : '#ffffff',
                        borderRadius: 8,
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    },
                },
            },
            MuiGrid: {
                styleOverrides: {
                    item: {
                        backgroundColor: 'transparent',
                        margin: '0 auto',
                    },
                },
            },
            MuiAppBar: {
                styleOverrides: {
                    root: {
                        backgroundColor: themeMode === 'dark' ? '#333333' : '#ffffff',
                        color: themeMode === 'dark' ? '#ffffff' : '#000000',
                    },
                },
            },
        },
    });


